<template>
  <v-container>
    <!-- Mirrors the mobile Support screen (snappy-app/app/(protected)/support). -->
    <div class="mb-8">
      <h4 class="mb-3">Customer Support</h4>
      <div
        class="bg-white border border-solid border-gray-200 rounded-2xl p-4 flex flex-row items-center justify-around"
      >
        <button class="text-center" @click="openLiveChat">
          <img
            src="../../assets/img/contacts/help-desk.png"
            alt="Live Chat"
            class="w-10 h-10 mx-auto"
          />
          <p class="text-sm text-gray-700 mt-2 mb-0">Live Chat</p>
        </button>
        <a
          v-for="(number, index) in whatsappNumbers"
          :key="number"
          :href="`https://wa.me/${number}`"
          target="_blank"
          rel="noopener"
          class="text-center block"
        >
          <img
            src="../../assets/img/contacts/whatsapp.png"
            alt="WhatsApp"
            class="w-10 h-10 mx-auto"
          />
          <p class="text-sm text-gray-700 mt-2 mb-0">
            WhatsApp{{ index > 0 ? ` ${index + 1}` : '' }}
          </p>
        </a>
      </div>
    </div>

    <div>
      <h4 class="mb-3">Follow SnappyExchange</h4>
      <div
        class="bg-white border border-solid border-gray-200 rounded-2xl p-4 flex flex-row flex-wrap items-center gap-6"
      >
        <a
          v-for="social in socials"
          :key="social.label"
          :href="social.url"
          target="_blank"
          rel="noopener"
          class="text-center block"
        >
          <img :src="social.icon" :alt="social.label" class="w-9 h-9 mx-auto" />
          <p class="text-xs text-gray-700 mt-2 mb-0">{{ social.label }}</p>
        </a>
      </div>
    </div>
  </v-container>
</template>

<script>
import facebook from '../../assets/img/contacts/facebook.png'
import instagram from '../../assets/img/contacts/instagram.png'
import twitter from '../../assets/img/contacts/twitter.png'
import youtube from '../../assets/img/contacts/youtube.png'
import telegram from '../../assets/img/contacts/telegram.png'

export default {
  data() {
    return {
      whatsappNumbers: ['2348156010101', '2348180660000'],
      socials: [
        {
          label: 'Facebook',
          url: 'https://facebook.com/snappyexchange',
          icon: facebook
        },
        {
          label: 'Instagram',
          url: 'https://instagram.com/snappyexchangeng',
          icon: instagram
        },
        {
          label: 'X (Twitter)',
          url: 'https://twitter.com/snappyexchange',
          icon: twitter
        },
        {
          label: 'YouTube',
          url: 'https://youtube.com/@snappyexchange',
          icon: youtube
        },
        {
          label: 'Telegram',
          url: 'https://t.me/snappyexchange',
          icon: telegram
        }
      ]
    }
  },
  methods: {
    openLiveChat() {
      // Freshchat widget loaded in layouts/User.vue.
      if (window.fcWidget) window.fcWidget.open()
    }
  }
}
</script>
